const Download = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      d="M10 2.5v10.833m0 0 3.334-3.646M10 13.333 6.667 9.688M2.5 15.25c0 2.357 0 3.535.732 4.268.733.732 1.911.732 4.268.732h5c2.357 0 3.535 0 4.268-.732.732-.733.732-1.911.732-4.268"
    />
  </svg>
);

export default Download;
